import React from 'react'
import styled, { keyframes } from 'styled-components'
import { accents } from 'sutra/tokens/colors'

// Shared "agent run" icons — list page (LatestFindingsCell) and detail page
// (ActivityFeed) render the same glyphs for the same states.

const spin = keyframes`
  to { transform: rotate(360deg); }
`

export const AutoplayIcon: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M7.08333 12.875V5.375L12.9167 9.125L7.08333 12.875ZM9.16667 18.2917C7.66667 18.2917 6.26042 17.9479 4.94792 17.2604C3.63542 16.5729 2.54167 15.6111 1.66667 14.375V16.625H0V11.625H5V13.2917H2.95833C3.66667 14.3333 4.56597 15.1493 5.65625 15.7396C6.74653 16.3299 7.91667 16.625 9.16667 16.625C10.7639 16.625 12.2118 16.1667 13.5104 15.25C14.809 14.3333 15.7222 13.1181 16.25 11.6042L17.875 11.9792C17.25 13.8681 16.1389 15.3924 14.5417 16.5521C12.9444 17.7118 11.1528 18.2917 9.16667 18.2917ZM0.0416667 8.29167C0.138889 7.36111 0.361111 6.46875 0.708333 5.61458C1.05556 4.76042 1.53472 3.97222 2.14583 3.25L3.33333 4.4375C2.88889 5.00695 2.52778 5.61458 2.25 6.26042C1.97222 6.90625 1.79861 7.58333 1.72917 8.29167H0.0416667ZM4.5 3.27083L3.3125 2.08333C4.04861 1.47222 4.84028 0.989583 5.6875 0.635417C6.53472 0.28125 7.41667 0.0694444 8.33333 0V1.66667C7.625 1.73611 6.95139 1.90972 6.3125 2.1875C5.67361 2.46528 5.06944 2.82639 4.5 3.27083ZM13.8542 3.27083C13.2847 2.82639 12.6771 2.46528 12.0313 2.1875C11.3854 1.90972 10.7083 1.73611 10 1.66667V0C10.9306 0.0833333 11.8229 0.298611 12.6771 0.645833C13.5313 0.993056 14.3194 1.47222 15.0417 2.08333L13.8542 3.27083ZM16.625 8.29167C16.5556 7.58333 16.3819 6.90625 16.1042 6.26042C15.8264 5.61458 15.4653 5.00695 15.0208 4.4375L16.2083 3.25C16.8194 3.97222 17.2986 4.76042 17.6458 5.61458C17.9931 6.46875 18.2083 7.36111 18.2917 8.29167H16.625Z"
      fill="currentColor"
    />
  </svg>
)

export const AgentRunSpinner = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #dbe1e8;
  border-top-color: ${accents.reflectionBlue[500]};
  border-radius: 50%;
  animation: ${spin} 800ms linear infinite;
  flex-shrink: 0;
`
